"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashObject = void 0;
var hash_string_1 = require("./hash-string");
function hashObject(obj) {
    if (obj.prototype) {
        throw new RangeError("Can only hash a plain object");
    }
    return hash_string_1.hashString(JSON.stringify(obj));
}
exports.hashObject = hashObject;
//# sourceMappingURL=hash-object.js.map